export const INVALID_ID = "validationMessages.invalidId";
export const EMAIL_MESSAGE = "validationMessages.invalidEmail";
export const NUMERIC_MESSAGE = "validationMessages.numericMessage";
export const MIN_LENGTH_MESSAGE = (value: string) =>
  `${"validationMessages.minLengthMessage"}/${value}`;
export const MAX_LENGTH_MESSAGE = (value: string) =>
  `${"validationMessages.maxLengthMessage"}/${value}`;
export const MIN_VALUE_MESSAGE = (value: string) =>
  `${"validationMessages.minValueMessage"}/${value}`;
export const POSITIVE_VALUE_MESSAGE = "validationMessages.positiveValueMessage";
export const INVALID_DATE_MESSAGE = "validationMessages.invalidDateMessage";
export const ENUM_MESSAGE = "validationMessages.enumMessage";
export const REQUIRED_MESSAGE = "validationMessages.requiredMessage";
export const PASSWORD_RULE_MESSAGE = "validationMessages.passwordRuleMessage";
export const EQUAL_PASSWORD_MESSAGE = "validationMessages.equalPasswordMessage";
export const ACCEPT_TERMS_MESSAGE = "validationMessages.acceptTermsMessage";
export const INVALID_OPTION_MESSAGE = "validationMessages.invalidOptionMessage";
export const SELECT_PARTNER_TYPE_MESSAGE = "validationMessages.selectPartnerType";
export const SELECT_BUSINESS_CLASSIFICATION_MESSAGE = "validationMessages.selectBusinessClassification";
export const SELECT_COMPANY_LOGO_MESSAGE = "validationMessages.selectCompanyLogo";
export const SELECT_CNPJ_CARD_MESSAGE = "validationMessages.selectCnpjCard";
export const SELECT_CONTRACT_DOCUMENT_MESSAGE = "validationMessages.selectContractDocument";
export const SELECT_AT_LEAST_ONE_CONTRACT_MESSAGE = "validationMessages.selectAtLeastOneContract";
